export function useAzira() {
  function trackLandingPage(): void {
    const pixel = new Image()
    pixel.src =
      'https://cnv.event.prod.bidr.io/log/cnv?tag_id=9&buzz_key=azira&value=&segment_key=azira-187&account_id=12&ord={{CACHEBUSTER}}'
    pixel.width = 1
    pixel.height = 1
  }

  function trackConversion(): void {
    const pixel = new Image()
    pixel.src =
      'https://cnv.event.prod.bidr.io/log/cnv?tag_id=10&buzz_key=azira&value=&segment_key=&account_id=12&ord={{CACHEBUSTER}}'
    pixel.width = 1
    pixel.height = 1
  }

  function trackUplift(): void {
    const pixel = new Image()
    pixel.src = 'https://pixel.zprk.io/v5/pixel/Eu2ELz8f2n.gif?ssid=1'
    pixel.width = 1
    pixel.height = 1
    pixel.alt = ''
  }

  return {
    trackLandingPage,
    trackConversion,
    trackUplift
  }
}
